import { z } from "zod";
import moment from "moment";

export function buildAddCouponSchema(
  minimumPrice: number,
  sessionAppointmentPrice: number,
) {
  return z
    .object({
      code: z
        .string()
        .min(6, "Informe um código com no mínimo 6 caracteres")
        .max(20, "Informe um código com no máximo 20 caracteres"),
      percent_off: z.string().min(1, "Informe a porcentagem do desconto"),
      has_redemption: z.boolean(),
      has_limit: z.boolean(),
      redeem_by: z.string(),
      max_redemptions_customers: z.string(),
    })
    .superRefine((data, ctx) => {
      const percent = parseInt(data.percent_off);
      if (!(percent >= 5 && percent <= 90)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["percent_off"],
          message: "Informe um valor entre 5% e 90%",
        });
      } else {
        const discount = (percent / 100) * sessionAppointmentPrice;
        const finalValue = sessionAppointmentPrice - discount;
        if (finalValue < minimumPrice) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["percent_off"],
            message: `Valor final não pode ser inferior a R$${minimumPrice}.`,
          });
        }
      }

      if (data.has_redemption) {
        if (!data.redeem_by) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["redeem_by"],
            message: "Informe a data de validade do código",
          });
        } else {
          const split = data.redeem_by.split("/");
          const date = `${split[2]}-${split[1]}-${split[0]}`;
          if (!(moment(date).isValid() && moment(date).isAfter())) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              path: ["redeem_by"],
              message: "Informe uma data válida",
            });
          }
        }
      }

      if (data.has_limit && !data.max_redemptions_customers) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["max_redemptions_customers"],
          message: "Informe o limite de uso do código",
        });
      }
    });
}
export type AddCouponValues = z.infer<ReturnType<typeof buildAddCouponSchema>>;
